<template>
  <div class="laboratoryManagement">
    <header>
      <div class="title">管理痛点</div>
      <ManagementPainPoints :list="MANAGE_LIST"></ManagementPainPoints>
    </header>
    <main>
      <div class="title">方案亮点</div>
      <TabLights :list="LIGHTS"></TabLights>
    </main>
    <section class="wow animate__animated animate__fadeIn">
      <div class="title">方案优势</div>
      <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
      <div class="title">流程管控</div>
      <div class="lc-title">细节流程处理，管控每一环节安全处理</div>
      <div class="lc">
        <div class="lc-left">
          <OssImg src="images/solution/chemicalControl/lc.png" alt="" />
        </div>
        <div class="lc-right">
          <div class="lcList">
            <div class="lc-item maria" v-for="item in LC_LIST" :key="item.key">
              <img :src="item.imgPath" style="width: 70px;height: 70px;"/>
              <div>
                <div class="lc-t">{{ item.text }}</div>
                <div class="lc-desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="wow animate__animated animate__fadeIn">
      <div class="title">硬件支持</div>
      <div class="friends">
        <div
          class="friendItem"
          v-for="(item, index) in HARD_WARE"
          :key="index"
          @click="handleSeeDetail"
        >
          <el-card shadow="hover">
            <template #default>
              <div class="f-img">
                <img :src="item.imgPath" style="width: 100%" />
              </div>
              <div class="f-title">{{ item.name }}</div>
              <!-- <div class="f-desc">
                复旦大学遗传工程国家重点实验室引入数台危化品智能安全柜
              </div> -->
            </template>
          </el-card>
        </div>
        <!-- <div class="btn">更多案例</div> -->
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref,onMounted } from "vue";
import ManagementPainPoints from "./components/ManagementPainPoints.vue";
import TabLights from "./components/TabLights.vue";
import Advantage from "./components/Advantage.vue";
import { WOW } from 'wowjs'
import OssImg from "@/components/ossImg.vue";

onMounted(() => {
  const wow = new WOW();
  wow.init();
})

const MANAGE_LIST = ref([
  {
    iconPath: "images/solution/chemicalControl/icon1.png",
    title: "全流程管控脱节",
    desc: "采购、入库、领用等环节依赖纸质单据，信息传递缓慢，常出现账实不符，危化品流向追溯困难，管理效率低下且存在监管盲区",
    key: 0,
  },
  {
    iconPath: "images/solution/chemicalControl/icon2.png",
    title: "存储安全风险高",
    desc: "人工巡检难以实时监测温湿度、气体浓度等环境参数，危化品泄漏、超温等隐患无法及时察觉；同时，不同危化品混存现象普遍，极易因兼容性问题引发安全事故",
    key: 1,
  },
  {
    iconPath: "images/solution/chemicalControl/icon3.png",
    title: "合规审计压力大",
    desc: "危险等级分类、台账记录等工作人工操作易出错，面对安监、环保部门的合规检查时，难以快速响应，违规风险高，一旦被查，将面临严厉处罚",
    key: 2,
  },
  {
    iconPath: "images/solution/chemicalControl/icon4.png",
    title: "库存管理不科学",
    desc: "依赖经验进行采购，容易造成化学品积压或断货；保质期管理依靠人工统计，无法及时处理过期化学品，不仅浪费资源，还带来严重的安全隐患",
    key: 3,
  },
]);
const LIGHTS = ref([
  {
    tabText: "智能闭环管控",
    title: "全流程智能闭环管控",
    desc: "将采购审批、入库登记、领用核销、报废处置等环节打通，实现数据实时同步与自动流转。通过电子标签、扫码识别等技术，精准追踪危化品流向，彻底解决账实不符难题，形成可追溯、透明化的管理闭环",
    imgPath: "images/UIV2/solution4.png",
    key: 0,
  },
  {
    tabText: "智慧化存储安全体系",
    title: "智慧化存储安全体系",
    desc: "部署物联网传感器与 AI 监测系统，24 小时实时采集温湿度、气体浓度等环境数据，对泄漏、超温等异常情况秒级预警。采用危化品智能存储安全柜，防爆防腐，双门双锁，电子台账，规避风险，全方位守护存储安全",
    imgPath: "images/UIV2/solution5.png",
    key: 1,
  },
  {
    tabText: "AI 驱动的智能库存管理",
    title: "AI 驱动的智能库存管理",
    desc: "大数据分析采购历史、实验需求等数据，预测化学品消耗趋势，智能生成采购建议，避免积压与断货。同时，自动监控保质期，提前推送过期预警，并提供报废处理流程指引，优化库存成本，消除过期化学品安全隐患",
    imgPath: "images/UIV2/solution6.png",
    key: 2,
  },
]);

const TECHNICAL_CAPACITY = ref([
  // {
  //   title: "创新模块化硬件设计",
  //   desc: "模块式智能组合柜，采用突破性的模块化构造。可依据危化品的易燃、腐蚀、有毒等不同特性，自由组合存储单元，达成 “一区一品” 的精准存储管理，有效规避因化学品混放引发的安全风险",
  //   imgPath: "images/solution/chemicalControl/big_icon1.png",
  //   key: 0,
  // },
  // {
  //   title: "全方位智能感知预警",
  //   desc: "每一个独立的存储单元格内，都搭载了温湿度、气体浓度等多种传感器，并结合先进的 AI 算法，实现 24 小时不间断的动态监测。一旦检测到数据异常，系统能在瞬间触发声光报警，同时自动联动通风、中和等应急装置，将安全隐患扼杀在萌芽状态",
  //   imgPath: "images/solution/chemicalControl/big_icon2.png",
  //   key: 1,
  // },
  // {
  //   title: "全流程数字化管控",
  //   desc: "从化学品的采购申请、入库登记，到领用、使用、归还以及最后的报废处置，实现全流程的数字化操作与管理。通过电子标签、扫码识别、RFID 射频识别等技术，精准追踪每一瓶危化品的流向，自动生成详细且准确的电子台账，彻底解决传统管理中账实不符、信息滞后的难题",
  //   imgPath: "images/solution/chemicalControl/big_icon3.png",
  //   key: 2,
  // },
  // {
  //   title: "严格合规适配性",
  //   desc: "紧密贴合《危险化学品安全管理条例》等相关法规要求，方案全面支持 “五双管理”（双人保管、双人领取、双人使用、双把锁、双本账）。在人员操作层面，集成人脸识别 + RFID 刷卡双认证方式，配合双目摄像头对操作者身份进行核验，确保操作责任落实到人",
  //   imgPath: "images/solution/chemicalControl/big_icon4.png",
  //   key: 3,
  // },
  // {
  //   title: "智能数据分析决策",
  //   desc: "借助大数据分析技术，深入挖掘采购历史、实验消耗数据等信息，精准预测化学品的消耗趋势。系统智能生成采购建议，自动监控化学品保质期，提前推送过期预警，并提供报废处理流程指引",
  //   imgPath: "images/solution/chemicalControl/big_icon5.png",
  //   key: 4,
  // },
  // {
  //   title: "强大产学研合作支撑",
  //   desc: "耀客物联与华中科技大学、复旦大学等知名高校展开深度产学研合作。为方案提供前沿技术支持与理论指导，如在危险化学品安全智能管控平台的研发中，共同攻克技术难题，使得方案始终处于技术领先",
  //   imgPath: require('/UIV3/step1.png'),
  //   key: 5,
  // },
]);
const LC_LIST = ref([
  // {
  //   imgPath: require('/UIV3/step2.png'),
  //   text: "管制类型单类单审",
  //   desc: "针对于管制类和非管制类化学品，可在购买申请或使用申请时可分类配置审批流程,保障管制类严格且规范",
  //   key: 0,
  // },
  // {
  //   imgPath: require('/UIV3/step2.png'),
  //   text: "存储配伍时刻监控",
  //   desc: "内置化学品存储配伍禁忌数据库，智能规划存储布局，自动检测混存风险，实时预警，保障存储安全合规",
  //   key: 1,
  // },
  // {
  //   imgPath: require('/UIV3/step3.png'),
  //   text: "双门双锁多形式验证",
  //   desc: "多种核验方式，身份核验机制明确操作责任，一旦出现问题可快速追溯，增强人员安全意识与责任感，形成严谨的安全管理氛围",
  //   key: 2,
  // },
]);
const HARD_WARE = ref([
  // {
  //   imgPath: require("/UIV3/device1.png"),
  //   name: "耐火防爆智能柜",
  // },
  // {
  //   imgPath: require("/UIV3/device2.png"),
  //   name: "六分区智能柜",
  // },
  // {
  //   imgPath: require("/UIV3/device3.png"),
  //   name: "中控台",
  // },
  // {
  //   imgPath: require("/UIV3/device4.png"),
  //   name: "模块式组合柜",
  // },
]);
</script>

<style lang="scss" scoped>
.laboratoryManagement {
  $titleSize: 60px;
  font-family: "PingFang SC";
  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 500;
    font-size: $titleSize;
    text-align: center;
  }
  main {
    margin: 56px;
  }
  section {
    .lc-title {
      color: #424242;
      text-align: center;
      font-weight: 600;
      font-size: 32px;
      margin: 24px 0px 50px 0px;
    }
    .lc {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
      .lc-left {
      }
      .lc-right {
        .lcList {
          display: flex;
          flex-direction: column;
          gap: 24px;
          .lc-item {
            box-sizing: border-box;
            padding: 16px;
            width: 100%;
            height: 112px;
            border-radius: 16px;
            background: #ffffff;
            display: flex;
            align-items: center;
            gap: 16px;
            .lc-t {
              color: #424242;
              font-weight: 500;
              font-size: 16px;
              margin-bottom: 10px;
            }
            .lc-desc {
              color: #888888;
              font-weight: 500;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  footer {
    margin-top: 56px;
    .friends {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .friendItem {
        width: 24%;
        height: 334px;
        margin-bottom: 32px;
        cursor: pointer;
        .f-img {
          width: 100%;
          height: 280px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            &:hover {
              transform: scale(1.1);
              transition: all 1s ease-in-out;
            }
          }
        }
        .f-title {
          color: #424242;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          margin: 13px 0px;
          padding: 0px 16px;
        }
        .f-desc {
          color: #888888;
          font-weight: 500;
          font-size: 14px;
          padding: 0px 16px;
        }
        .el-card {
          border-radius: 16px;
          height: 334px;
          :deep(.el-card__body) {
            padding: 0px;
          }
        }
      }
    }
    .btn {
      margin: 32px auto 126px;
      width: 97px;
      height: 40px;
      border-radius: 8px;
      background: #32A89E;
      color: #ffffff;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      line-height: 35px;
      cursor: pointer;
    }
  }
}
</style>
